import React, { useState } from 'react';
import styled from 'styled-components';

import { Input } from '@/components/shared/Input';
import { EyeToggleIcon } from './EyeToggleIcon';
import './css/index.css';

type Props = {
  dataTestId?: string;
  error?: boolean;
  id: string;
  label: string;
  placeholder?: string;
  value: string;
  strengthMeter?: (p: string) => number; // 0...4
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

export const PasswordField: React.FC<Props> = ({
  dataTestId = 'password-field',
  error = false,
  id,
  label,
  placeholder = '',
  value,
  strengthMeter,
  onChange,
  onBlur,
}) => {
  const [visible, setVisible] = useState(false);

  let withStrength = false;
  let strengthScore = 0;

  if (strengthMeter) {
    withStrength = true;
    strengthScore = strengthMeter(value);
  }

  return (
    <>
      <label htmlFor={id}>{label}</label>
      <StyledInput>
        <PasswordInput
          autoComplete="new-password"
          className={error ? ' is-error' : ''}
          data-test={dataTestId}
          id={id}
          placeholder={placeholder}
          type={visible ? 'text' : 'password'}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
        />
        <EyeToggleIcon visible={visible} onClick={() => setVisible(!visible)} />
      </StyledInput>
      {withStrength && (
        <>
          <span className="strength" data-score={strengthScore} />
          <div className="judgement">{strengthScore < 2 ? '　' : 'OK'}</div>
        </>
      )}
    </>
  );
};

const StyledInput = styled.div`
  width: 100%;
  position: relative;
  font-weight: 400;
  font-style: normal;
  display: inline-flex;
  color: rgba(0, 0, 0, 0.87);
`;

const PasswordInput = styled(Input)`
  padding-right: 42.7px;
`;
